import React, {PureComponent} from 'react';
import ReactQuill from 'react-quill';
import ReactPaginate from 'react-paginate';
import {modules, formats} from 'constants/baseConst';
import {InputText} from '../../blocks/inputs/InputText';
import Checkbox from 'material-ui/Checkbox';
import _ from 'lodash';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
// import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import { inject, observer } from 'mobx-react';
// import {REIMBURSEMENT_TYPE, REIMBURSEMENT_TYPES} from 'constants/reimbursementTypes';

@inject('topicsStore')
@observer
class Quiz extends PureComponent {
  changeQuiz = (e, value, index) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    const obj = newQuiz[index];
    obj[e.target.name] = value;
    newQuiz[index] = obj;

    topicsStore.handleChangeQuiz(newQuiz);
  }

  handleHideQuiz = () => {
    const {topicsStore} = this.props;
    const is_visible_quize = !topicsStore.topic.is_visible_quize;
    topicsStore.handleChange({is_visible_quize});
  }

  handleType = (e) => {
    const {topicsStore} = this.props;

    topicsStore.handleChange({ [e.target.name]: e.target.value });
    topicsStore.clearQuizes();
  }

  handleAddOption = key => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    newQuiz[key].options.push({
      body: '',
      correct: ''
    })

    topicsStore.addQuizOption(newQuiz);
  };

  handleRemoveOption = (index, key) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    newQuiz[index].options.splice(key, 1);

    topicsStore.addQuizOption(newQuiz);
  };

  changeQuizOption = (e, value, index, key) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    const obj = newQuiz[index].options[key];
    obj[e.target.name] = value;
    newQuiz[index].options[key] = obj;

    this.props.topicsStore.handleChangeQuiz(newQuiz);
  }

  render() {
    const {topicsStore, nextQuestions, totalPages} = this.props;
    const spd_quizzes = topicsStore.topic.spd_quizzes || [];
    const sortedQuizzes = _.sortBy(spd_quizzes, 'id');
    // const errors = topicsStore.errors || {};
    // const reimbursementType = REIMBURSEMENT_TYPES[topicsStore.topic.reimbursement_type] || REIMBURSEMENT_TYPES[topicsStore.topic.reimbursement_type] === 0 ?
    //   REIMBURSEMENT_TYPES[topicsStore.topic.reimbursement_type] : topicsStore.topic.reimbursement_type;

    return (
      <div className="tab-container">
        <div className="row justify-content-center">
          <h3 className='container-header'>Add Quiz</h3>
        </div>
        <div className='row'>
          <div className="col-12 container-body">
            <div className="quiz-conatiner" style={{margin: '25px auto'}}>
              <Checkbox
                label='Show quiz'
                checked={topicsStore.topic.is_visible_quize}
                onCheck={this.handleHideQuiz}
              />
            </div>
          </div>
        </div>
        {/* {topicsStore.topic.is_visible_quize && (
          <div className='row'>
            <div className="col-12 container-body">
              <div className="quiz-conatiner" style={{margin: "25px auto"}}>
                <SelectFieldWrapper
                  elements={REIMBURSEMENT_TYPE}
                  placeholder="Reimbursement type:"
                  name='reimbursement_type'
                  value={reimbursementType}
                  onChange={this.handleType}
                  errorText={errors.reimbursement_type}
                  fullWidth={true}
                />
              </div>
            </div>
          </div>
        )} */}
        <div className="row">
          <div className="col-12 container-body">
            <div className="quiz-conatiner">
              { sortedQuizzes.map( (el, idx) =>
                <div className="quiz-wrapper" key={idx}>
                  <InputText
                    label={`${idx + 1} Question Title`}
                    fullWidth={true}
                    onChange={(e) => this.changeQuiz(e, e.target.value, idx)}
                    name='question'
                    value={el.question}
                    type="text"
                    errorText={topicsStore.getErrorToQuiz(idx).question}
                    placeholder='Question Title'
                  />
                  {/* {reimbursementType !== 1 ? (
                    <RadioButtonGroup
                      name="correct"
                      defaultSelected="true"
                      className='quiz-answers'
                      onChange={(e, newValue) => this.changeQuiz(e, newValue, idx)}
                      valueSelected={el.correct.toString()}
                    >
                      <RadioButton
                        value="true"
                        label="TRUE"
                      />
                      <RadioButton
                        value="false"
                        label="FALSE"
                      />
                    </RadioButtonGroup>
                  ) : */}
                  {/* ( */}
                    <div>
                      {el.options.map((option, key) => (
                        <div key={key} style={{margin: '16px 0'}}>
                          <div style={{display: 'flex'}}>
                            <InputText
                              label="Option body"
                              onChange={(e) => this.changeQuizOption(e, e.target.value, idx, key)}
                              name='body'
                              value={option.body}
                              type="text"
                              style={{width: '50%'}}
                              placeholder='Option body'
                            />
                            <button className="btn" style={{padding: 0, margin: '8px 0', color: '#467093'}} onClick={() => this.handleRemoveOption(idx, key)}>Remove option</button>
                          </div>
                          <RadioButtonGroup
                            name="correct"
                            defaultSelected="true"
                            className='quiz-answers'
                            onChange={(e, newValue) => this.changeQuizOption(e, newValue, idx, key)}
                            valueSelected={option.correct.toString()}
                          >
                            <RadioButton
                              value="true"
                              label="TRUE"
                            />
                            <RadioButton
                              value="false"
                              label="FALSE"
                            />
                          </RadioButtonGroup>
                        </div>
                      ))}
                      <button className="btn" style={{padding: 0, minWidth: 0, margin: '8px 0', color: '#467093'}} onClick={() => this.handleAddOption(idx)}>+ Add option</button>
                      <ReactQuill
                        name={ 'key_learnings' }
                        placeholder={ 'Key learning points' }
                        value={ el.key_learnings || '' }
                        onChange={ (key_learnings) => this.changeQuiz({target: {name: 'key_learnings'}}, key_learnings, idx) }
                        modules={ modules }
                        formats={ formats }
                        className="quill-toolbar-position"
                      >
                        <div style={{ width: '100%', margin: '16px', border: 0 }}></div>
                      </ReactQuill>
                      <ReactQuill
                        name={ 'explanation' }
                        placeholder={ 'Explanation' }
                        value={ el.explanation || '' }
                        onChange={ (explanation) => this.changeQuiz({target: {name: 'explanation'}}, explanation, idx) }
                        modules={ modules }
                        formats={ formats }
                        className="quill-toolbar-position"
                      >
                        <div style={{ width: '100%', margin: '16px', border: 0 }}></div>
                      </ReactQuill>
                    </div>
                  {/* )} */}
                </div>
              )}
            </div>
          </div>
          <ReactPaginate
            containerClassName="react-paginate"
            pageCount={totalPages}
            onPageChange={nextQuestions}
          />
        </div>
      </div>
    );
  }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/modules/topic/components/Quiz.js